import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false,
    key: null,
    requestId: null
};
var getAddressProvinceSlice = createSlice({
    name: "getAddressProvince",
    initialState: initialState,
    reducers: {
        fetchData: function(state, param) {
            var payload = param.payload;
            state.data = null;
            state.isFetching = true;
            state.isError = false;
            state.key = payload.key;
            state.requestId = payload.requestId;
        },
        fetchDataSuccess: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.data = payload.data;
            state.isFetching = false;
        },
        fetchDataFailure: function(state, param) {
            var payload = param.payload;
            if (state.requestId !== payload.requestId) return;
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAddressProvinceSlice_actions = getAddressProvinceSlice.actions;
export var fetchData = _getAddressProvinceSlice_actions.fetchData, fetchDataSuccess = _getAddressProvinceSlice_actions.fetchDataSuccess, fetchDataFailure = _getAddressProvinceSlice_actions.fetchDataFailure, resetState = _getAddressProvinceSlice_actions.resetState;
export default getAddressProvinceSlice.reducer;
